/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum AppCrehanaFaqEnum {
  ACADEMIES = 'ACADEMIES',
  B2B_CLASSROOM = 'B2B_CLASSROOM',
  B2B_DETAIL = 'B2B_DETAIL',
  B2B_LANDING = 'B2B_LANDING',
  COURSE_DETAIL = 'COURSE_DETAIL',
  DEGREE_DETAIL = 'DEGREE_DETAIL',
  MARATHON_LANDING = 'MARATHON_LANDING',
  MEMBERSHIP_DETAIL = 'MEMBERSHIP_DETAIL',
}

export enum ApprovalRequirementEnum {
  FINAL_PROJECT = 'FINAL_PROJECT',
  NOT_REQUIREMENT = 'NOT_REQUIREMENT',
  QUIZ_EVALUATION = 'QUIZ_EVALUATION',
}

export enum CertificateTypeEnum {
  ACADEMY_SKILL_PATH = 'ACADEMY_SKILL_PATH',
  B2B_TRACK = 'B2B_TRACK',
  CAREER = 'CAREER',
  CERTIFICATION = 'CERTIFICATION',
  COURSE = 'COURSE',
}

export enum CourseTypeEnum {
  COURSE_TYPE_B2B = 'COURSE_TYPE_B2B',
  COURSE_TYPE_B2B_CLASSROOMS = 'COURSE_TYPE_B2B_CLASSROOMS',
  COURSE_TYPE_DEGREE = 'COURSE_TYPE_DEGREE',
  COURSE_TYPE_FREE = 'COURSE_TYPE_FREE',
  COURSE_TYPE_MEMBERSHIP = 'COURSE_TYPE_MEMBERSHIP',
  COURSE_TYPE_PAID = 'COURSE_TYPE_PAID',
  COURSE_TYPE_ROCKSTAR = 'COURSE_TYPE_ROCKSTAR',
  COURSE_TYPE_TEMPORAL_ACCESS = 'COURSE_TYPE_TEMPORAL_ACCESS',
}

export enum CourseVideoTrailerSourceVideoSourceType {
  HLSV3 = 'HLSV3',
  HLSV4 = 'HLSV4',
  MP3 = 'MP3',
  MP4 = 'MP4',
  NONE = 'NONE',
}

export enum DegreeLearningEventScheduleTargetEnum {
  TARGET_COMPLEMENTARY_SESSION = 'TARGET_COMPLEMENTARY_SESSION',
  TARGET_COUNSELLING = 'TARGET_COUNSELLING',
  TARGET_KICKOFF = 'TARGET_KICKOFF',
}

export enum DegreeSyllabusStatusEnum {
  STATUS_CLOSURE = 'STATUS_CLOSURE',
  STATUS_FINISHED = 'STATUS_FINISHED',
  STATUS_ONBOARDING = 'STATUS_ONBOARDING',
  STATUS_PROGRESS = 'STATUS_PROGRESS',
  STATUS_SALE = 'STATUS_SALE',
}

export enum EnrollmentTypeEnum {
  ENROLLMENT_B2B = 'ENROLLMENT_B2B',
  ENROLLMENT_DEGREE = 'ENROLLMENT_DEGREE',
  ENROLLMENT_FREE = 'ENROLLMENT_FREE',
  ENROLLMENT_FREEMIUM = 'ENROLLMENT_FREEMIUM',
  ENROLLMENT_FREE_MEMBERSHIP = 'ENROLLMENT_FREE_MEMBERSHIP',
  ENROLLMENT_GITCARD = 'ENROLLMENT_GITCARD',
  ENROLLMENT_MEMBERSHIP = 'ENROLLMENT_MEMBERSHIP',
  ENROLLMENT_MENTOR = 'ENROLLMENT_MENTOR',
  ENROLLMENT_PAID = 'ENROLLMENT_PAID',
  ENROLLMENT_PREVIEW_TRIAL = 'ENROLLMENT_PREVIEW_TRIAL',
  ENROLLMENT_PROFESSOR = 'ENROLLMENT_PROFESSOR',
  ENROLLMENT_STAFF = 'ENROLLMENT_STAFF',
  ENROLLMENT_TEMPORAL_ACCESS = 'ENROLLMENT_TEMPORAL_ACCESS',
}

export enum FeatureFlagsKey {
  AB_COURSE_TAG_NEW_30_DAYS = 'AB_COURSE_TAG_NEW_30_DAYS',
  ACTIVE_HOME_ORGANIZATION_V2 = 'ACTIVE_HOME_ORGANIZATION_V2',
  ACTIVE_PAYU_REFUND = 'ACTIVE_PAYU_REFUND',
  ALEGRA_INVOICE_DLOCAL_COLOMBIA = 'ALEGRA_INVOICE_DLOCAL_COLOMBIA',
  ALEGRA_SEND_DATA = 'ALEGRA_SEND_DATA',
  ALL_ACCESS_MARATHON = 'ALL_ACCESS_MARATHON',
  ANDROID_REFER_FRIEND_DISCOUNT = 'ANDROID_REFER_FRIEND_DISCOUNT',
  API_LINK_TRACKS = 'API_LINK_TRACKS',
  API_LINK_TRACKS_CLICK = 'API_LINK_TRACKS_CLICK',
  AUTH_REQUIRED_PHONE = 'AUTH_REQUIRED_PHONE',
  B2B_CHANGE_DATA_QUERY = 'B2B_CHANGE_DATA_QUERY',
  B2B_DOWNLOAD_NEW_REPORT = 'B2B_DOWNLOAD_NEW_REPORT',
  B2B_PAYMENTS_FORMS = 'B2B_PAYMENTS_FORMS',
  B2B_SKILL_IQ = 'B2B_SKILL_IQ',
  B2B_TAB_LIST_COURSES = 'B2B_TAB_LIST_COURSES',
  B2B_UPLOAD_USERS_EXCEL = 'B2B_UPLOAD_USERS_EXCEL',
  B2B_UPLOAD_USERS_TEAM = 'B2B_UPLOAD_USERS_TEAM',
  BLACKFRIDAY_ICONS_LANDING = 'BLACKFRIDAY_ICONS_LANDING',
  BLACK_FRIDAY_IN_ALL_PAGES = 'BLACK_FRIDAY_IN_ALL_PAGES',
  BLACK_FRIDAY_IN_SHOPPING_CART = 'BLACK_FRIDAY_IN_SHOPPING_CART',
  BLACK_FRIDAY_LOGO = 'BLACK_FRIDAY_LOGO',
  BLOCK_PAYMENT_PURCHASE = 'BLOCK_PAYMENT_PURCHASE',
  BUTTON_FACEBOOK_AUTH_HIDE = 'BUTTON_FACEBOOK_AUTH_HIDE',
  CACHED_CREHANA_CONVERSION = 'CACHED_CREHANA_CONVERSION',
  CACHED_CURRENCY_EXCHANGE = 'CACHED_CURRENCY_EXCHANGE',
  CAPTCHA_GUEST_CHECKOUT = 'CAPTCHA_GUEST_CHECKOUT',
  CHECKOUT_CARDS = 'CHECKOUT_CARDS',
  CHECKOUT_COURSE_TIMER = 'CHECKOUT_COURSE_TIMER',
  CHECKOUT_EXIT_POPUP = 'CHECKOUT_EXIT_POPUP',
  CHECKOUT_FAILED_PAYMENT_POPUP = 'CHECKOUT_FAILED_PAYMENT_POPUP',
  CHECKOUT_INCENTIVE_METHOD = 'CHECKOUT_INCENTIVE_METHOD',
  CHECKOUT_INFLUENCER_COUPON = 'CHECKOUT_INFLUENCER_COUPON',
  CHECKOUT_L10N_CAMPAIGN = 'CHECKOUT_L10N_CAMPAIGN',
  CHECKOUT_MEMBERSHIP_TIMER = 'CHECKOUT_MEMBERSHIP_TIMER',
  CHECKOUT_SHOW_CONTACT_NUMBER = 'CHECKOUT_SHOW_CONTACT_NUMBER',
  CHECKOUT_VALID_CREH_CREDIT = 'CHECKOUT_VALID_CREH_CREDIT',
  CHRISTMAS_CAMPAIGN = 'CHRISTMAS_CAMPAIGN',
  COMFAMA_ACTIVATE_API = 'COMFAMA_ACTIVATE_API',
  CONEKTA_PAYMENT_PROCESS = 'CONEKTA_PAYMENT_PROCESS',
  CONEKTA_SUSPECTED_FRAUD = 'CONEKTA_SUSPECTED_FRAUD',
  COURSE_DETAIL_CARDS = 'COURSE_DETAIL_CARDS',
  COURSE_DETAIL_MEMBERSHIP = 'COURSE_DETAIL_MEMBERSHIP',
  COURSE_DETAIL_V3 = 'COURSE_DETAIL_V3',
  COURSE_PREVIEW_TRIAL = 'COURSE_PREVIEW_TRIAL',
  CREATE_TRACK = 'CREATE_TRACK',
  CREATE_TRACKS_W_INTEGRATIONS = 'CREATE_TRACKS_W_INTEGRATIONS',
  CREHANATON_POPUP = 'CREHANATON_POPUP',
  CREHANA_CLASSROOM_SPOTLIGHT = 'CREHANA_CLASSROOM_SPOTLIGHT',
  CREHANA_DYNAMIC_PLAYLIST = 'CREHANA_DYNAMIC_PLAYLIST',
  CREHANA_HLSV3_B2B = 'CREHANA_HLSV3_B2B',
  CREHANA_MENTORSHIP = 'CREHANA_MENTORSHIP',
  CREHANA_VIDEO_PLAYER = 'CREHANA_VIDEO_PLAYER',
  ANALYTICS_VIDEO_PROGRESS_UNIFIED_QUERY = 'ANALYTICS_VIDEO_PROGRESS_UNIFIED_QUERY',
  CREHANA_VIDEO_TRANSCODER = 'CREHANA_VIDEO_TRANSCODER',
  CUSTOM_BUNDLE_IN_CATALOG = 'CUSTOM_BUNDLE_IN_CATALOG',
  DEAL_MEMBERSHIP_LANDING = 'DEAL_MEMBERSHIP_LANDING',
  DEGREE_FORCE_REDIRECT = 'DEGREE_FORCE_REDIRECT',
  DEGREE_ONBOARDING = 'DEGREE_ONBOARDING',
  DEGREE_STORE_UTM_PARAMS = 'DEGREE_STORE_UTM_PARAMS',
  DIRECT_CHANNEL = 'DIRECT_CHANNEL',
  DISABLE_B2C_ACAD_REQ_PROJECT = 'DISABLE_B2C_ACAD_REQ_PROJECT',
  DISABLE_BLACK_FRIDAY_2019 = 'DISABLE_BLACK_FRIDAY_2019',
  DYNAMO_CONNECTION = 'DYNAMO_CONNECTION',
  EBANX_CARD_PAYMENT_PROCESS = 'EBANX_CARD_PAYMENT_PROCESS',
  ENABLE_AMPLITUDE_TRACKS = 'ENABLE_AMPLITUDE_TRACKS',
  ENABLE_BLACKFRIDAY = 'ENABLE_BLACKFRIDAY',
  ENABLE_BLACKFRIDAY_2021 = 'ENABLE_BLACKFRIDAY_2021',
  ENABLE_BLACK_DAYS = 'ENABLE_BLACK_DAYS',
  ENABLE_BLACK_FRIDAY_FEATURES = 'ENABLE_BLACK_FRIDAY_FEATURES',
  ENABLE_CALL_CENTER_MENU_INPUT = 'ENABLE_CALL_CENTER_MENU_INPUT',
  ENABLE_CAMPAIGN_BANNER_PAGES = 'ENABLE_CAMPAIGN_BANNER_PAGES',
  ENABLE_CERTIF_VIA_VIEW_CLASS = 'ENABLE_CERTIF_VIA_VIEW_CLASS',
  ENABLE_CLASSROOM_ERROR_BANNER = 'ENABLE_CLASSROOM_ERROR_BANNER',
  ENABLE_COURSE_RELEASES = 'ENABLE_COURSE_RELEASES',
  ENABLE_CREHANA_SEARCH = 'ENABLE_CREHANA_SEARCH',
  ENABLE_CUSTOM_BUNDLE_REDESIGN = 'ENABLE_CUSTOM_BUNDLE_REDESIGN',
  ENABLE_CYBER = 'ENABLE_CYBER',
  ENABLE_EDUCATION_ACADEMIES = 'ENABLE_EDUCATION_ACADEMIES',
  ENABLE_FIRST_MILESTONE = 'ENABLE_FIRST_MILESTONE',
  ENABLE_GIFTCARD_V2 = 'ENABLE_GIFTCARD_V2',
  ENABLE_HERO_LEADS = 'ENABLE_HERO_LEADS',
  ENABLE_HOMEPAGE_CTA_CC_POPUP = 'ENABLE_HOMEPAGE_CTA_CC_POPUP',
  ENABLE_HOME_HERO_HOT_DAYS = 'ENABLE_HOME_HERO_HOT_DAYS',
  ENABLE_HOME_HERO_SECTION = 'ENABLE_HOME_HERO_SECTION',
  ENABLE_HOTSALE_BRANDING_2022 = 'ENABLE_HOTSALE_BRANDING_2022',
  ENABLE_HOT_SALE_MX = 'ENABLE_HOT_SALE_MX',
  ENABLE_INSERT_CASH_BACK = 'ENABLE_INSERT_CASH_BACK',
  ENABLE_INTEGRATIONS_MENU = 'ENABLE_INTEGRATIONS_MENU',
  ENABLE_MARATHON = 'ENABLE_MARATHON',
  ENABLE_MARATHON_CAN_ENROLL = 'ENABLE_MARATHON_CAN_ENROLL',
  ENABLE_MARATHON_HERO_V1 = 'ENABLE_MARATHON_HERO_V1',
  ENABLE_MARATHON_POPUP = 'ENABLE_MARATHON_POPUP',
  ENABLE_MARATHON_POPUP_PLAYER = 'ENABLE_MARATHON_POPUP_PLAYER',
  ENABLE_MARATHON_START_POPUP = 'ENABLE_MARATHON_START_POPUP',
  ENABLE_MERCADOPAGO_MX_QUOTAS = 'ENABLE_MERCADOPAGO_MX_QUOTAS',
  ENABLE_NEW_ASSIGNED_COURSE = 'ENABLE_NEW_ASSIGNED_COURSE',
  ENABLE_NEW_CH_PERMISSIONS = 'ENABLE_NEW_CH_PERMISSIONS',
  ENABLE_NEW_HOME_PAGE = 'ENABLE_NEW_HOME_PAGE',
  ENABLE_NEW_HOME_USER_B2B = 'ENABLE_NEW_HOME_USER_B2B',
  ENABLE_NOT_CONTACT_USER = 'ENABLE_NOT_CONTACT_USER',
  ENABLE_ONBOARDING = 'ENABLE_ONBOARDING',
  ENABLE_PAYMENT_METHOD_V2 = 'ENABLE_PAYMENT_METHOD_V2',
  ENABLE_PAYU_HOOK_DISPUTE = 'ENABLE_PAYU_HOOK_DISPUTE',
  ENABLE_PIPEDRIVE_LAMBDA = 'ENABLE_PIPEDRIVE_LAMBDA',
  ENABLE_RETARGETING_V2 = 'ENABLE_RETARGETING_V2',
  ENABLE_SAVED_COURSES = 'ENABLE_SAVED_COURSES',
  ENABLE_SEO_MODULE = 'ENABLE_SEO_MODULE',
  ENABLE_SOFE_MEMBERSHIP = 'ENABLE_SOFE_MEMBERSHIP',
  ENABLE_SOFE_MEMBERSHIP_BR = 'ENABLE_SOFE_MEMBERSHIP_BR',
  ENABLE_STUDIO_B2B = 'ENABLE_STUDIO_B2B',
  ENABLE_UNSUBSCRIBE_USER = 'ENABLE_UNSUBSCRIBE_USER',
  ENABLE_VALID_COUPON_IP = 'ENABLE_VALID_COUPON_IP',
  ENABLE_VIDEO_ANALYTICS_SENTRY = 'ENABLE_VIDEO_ANALYTICS_SENTRY',
  ENABLE_WHATSAPP = 'ENABLE_WHATSAPP',
  EXPIRE_MEMBERSHIP_GIFT = 'EXPIRE_MEMBERSHIP_GIFT',
  FACEBOOK_AUTH_HIDE = 'FACEBOOK_AUTH_HIDE',
  FACEBOOK_AUTH_LINK = 'FACEBOOK_AUTH_LINK',
  FB_ORDER_PURCHASED_CONVERSION = 'FB_ORDER_PURCHASED_CONVERSION',
  FLAG_CLASSIC_SHOPPING_CART = 'FLAG_CLASSIC_SHOPPING_CART',
  FLAG_CO_INTEGRATION = 'FLAG_CO_INTEGRATION',
  FLAG_CREHANA_CONVERSION = 'FLAG_CREHANA_CONVERSION',
  FLAG_DLOCAL_RECURRENT_PAY = 'FLAG_DLOCAL_RECURRENT_PAY',
  FLAG_ENABLE_NEW_RSS = 'FLAG_ENABLE_NEW_RSS',
  FLAG_EXTEND_ORDER_EXTRA_DATA = 'FLAG_EXTEND_ORDER_EXTRA_DATA',
  FLAG_MX_INTEGRATION = 'FLAG_MX_INTEGRATION',
  FLAG_NEW_CREDIT_CARD_FEATURE = 'FLAG_NEW_CREDIT_CARD_FEATURE',
  FLAG_NEW_HOME_TEMPLATE = 'FLAG_NEW_HOME_TEMPLATE',
  FLAG_NEW_USER_DISCOUNT = 'FLAG_NEW_USER_DISCOUNT',
  FLAG_PAGOEFECTIVO_REST = 'FLAG_PAGOEFECTIVO_REST',
  FLAG_PAYU_FALLBACK = 'FLAG_PAYU_FALLBACK',
  FLAG_PAYU_FORCE_FALLBACK = 'FLAG_PAYU_FORCE_FALLBACK',
  FLAG_PE_INTEGRATION = 'FLAG_PE_INTEGRATION',
  FLAG_SAP_INTEGRATION = 'FLAG_SAP_INTEGRATION',
  FLAG_TRANSLATION_IMAGES = 'FLAG_TRANSLATION_IMAGES',
  FLAG_US_INTEGRATION = 'FLAG_US_INTEGRATION',
  GOOGLE_ONE_TAB = 'GOOGLE_ONE_TAB',
  HOME_EDU_DAYS = 'HOME_EDU_DAYS',
  HOME_USER_APPS_AD_DIALOG = 'HOME_USER_APPS_AD_DIALOG',
  HOME_USER_DESKTOP_APPS_ADS = 'HOME_USER_DESKTOP_APPS_ADS',
  LEAD_DEGREE = 'LEAD_DEGREE',
  LESSONS_VERSION_FREE = 'LESSONS_VERSION_FREE',
  LESSONS_VERSION_PAYG = 'LESSONS_VERSION_PAYG',
  LESSONS_VERSION_PREMIUM = 'LESSONS_VERSION_PREMIUM',
  LESSONS_VERSION_STAFF = 'LESSONS_VERSION_STAFF',
  LINK_FACEBOOK_AUTH_HIDE = 'LINK_FACEBOOK_AUTH_HIDE',
  MAIN_MENU_DEAL = 'MAIN_MENU_DEAL',
  MEMBERSHIP_CALL_CENTER_DIALOG = 'MEMBERSHIP_CALL_CENTER_DIALOG',
  MEMBERSHIP_CL = 'MEMBERSHIP_CL',
  MEMBERSHIP_CO = 'MEMBERSHIP_CO',
  MEMBERSHIP_CR = 'MEMBERSHIP_CR',
  MEMBERSHIP_EC = 'MEMBERSHIP_EC',
  MEMBERSHIP_GB = 'MEMBERSHIP_GB',
  MEMBERSHIP_GT = 'MEMBERSHIP_GT',
  MEMBERSHIP_LANDING_MENU = 'MEMBERSHIP_LANDING_MENU',
  MEMBERSHIP_LOCAL_PRICES = 'MEMBERSHIP_LOCAL_PRICES',
  MEMBERSHIP_MX = 'MEMBERSHIP_MX',
  MEMBERSHIP_PA = 'MEMBERSHIP_PA',
  MEMBERSHIP_PE = 'MEMBERSHIP_PE',
  MEMBERSHIP_REDIRECTS = 'MEMBERSHIP_REDIRECTS',
  MEMBERSHIP_REVIEW_ALL_TAGS = 'MEMBERSHIP_REVIEW_ALL_TAGS',
  MEMBERSHIP_US = 'MEMBERSHIP_US',
  ML_RECOMMENDED_HOME_USER = 'ML_RECOMMENDED_HOME_USER',
  ML_RECOMMENDED_SHOPPING_CART = 'ML_RECOMMENDED_SHOPPING_CART',
  MONGO_CONNECTION = 'MONGO_CONNECTION',
  NEW_CATALOG = 'NEW_CATALOG',
  NOINDEX_CATALOG = 'NOINDEX_CATALOG',
  OFFBOARDING_ENABLE_ADD_MONTHS = 'OFFBOARDING_ENABLE_ADD_MONTHS',
  ORDER_CONFIRMATION_CASH_BACK = 'ORDER_CONFIRMATION_CASH_BACK',
  PHASE_TRANSITION_DIALOG = 'PHASE_TRANSITION_DIALOG',
  PLAYER_APPS_AD = 'PLAYER_APPS_AD',
  PREMIUM_MENU_DISCOUNT_ICON = 'PREMIUM_MENU_DISCOUNT_ICON',
  PRE_ALL_ACCESS_MARATHON = 'PRE_ALL_ACCESS_MARATHON',
  PROJECT_AT_VERSION_2_0 = 'PROJECT_AT_VERSION_2_0',
  PROJ_CREATION_COURSEDASHBOARD = 'PROJ_CREATION_COURSEDASHBOARD',
  PROJ_CREATION_USER_DASHBOARD = 'PROJ_CREATION_USER_DASHBOARD',
  PUBSUB_CERTIFICATES = 'PUBSUB_CERTIFICATES',
  PUBSUB_COURSE_HISTORY = 'PUBSUB_COURSE_HISTORY',
  PUSH_MEMBERSHIP_DISCOUNT = 'PUSH_MEMBERSHIP_DISCOUNT',
  REALTIME_PROFESSOR_RESUME = 'REALTIME_PROFESSOR_RESUME',
  REBRANDING_ACTIVE = 'REBRANDING_ACTIVE',
  REBRANDING_CATALOG = 'REBRANDING_CATALOG',
  REBRANDING_COURSE_LANDING = 'REBRANDING_COURSE_LANDING',
  REBRANDING_HOME = 'REBRANDING_HOME',
  REBRANDING_HOME_USER = 'REBRANDING_HOME_USER',
  RECEIVER_GIFTCARD = 'RECEIVER_GIFTCARD',
  RECEIVER_GIFT_CARD_CONFIRMED = 'RECEIVER_GIFT_CARD_CONFIRMED',
  RECOMMENDATION_ML = 'RECOMMENDATION_ML',
  REDIRECT_CONTACT_PAGE = 'REDIRECT_CONTACT_PAGE',
  REDIRECT_COURSES_FREE_BY_DAY = 'REDIRECT_COURSES_FREE_BY_DAY',
  REDIS_CONNECTION = 'REDIS_CONNECTION',
  REPORT_PROBLEM_INTEGRATION = 'REPORT_PROBLEM_INTEGRATION',
  ROULETTE_HOME = 'ROULETTE_HOME',
  SAVE_NOTIFICATION = 'SAVE_NOTIFICATION',
  SEARCH_WITH_HANA = 'SEARCH_WITH_HANA',
  SECOND_PURCHASE_DISCOUNT = 'SECOND_PURCHASE_DISCOUNT',
  SENDER_GIFTCARD = 'SENDER_GIFTCARD',
  SHOPPING_CART = 'SHOPPING_CART',
  SHOPPING_CART_UI = 'SHOPPING_CART_UI',
  SHOW_BLOG_LINK = 'SHOW_BLOG_LINK',
  SHOW_FREE_COURSE_SECTION = 'SHOW_FREE_COURSE_SECTION',
  SHOW_GIFT_MEMBERSHIP = 'SHOW_GIFT_MEMBERSHIP',
  SHOW_INSTAGRAM_TRAILER = 'SHOW_INSTAGRAM_TRAILER',
  SHOW_MARKETPLACE = 'SHOW_MARKETPLACE',
  SIGNUP_TWILIO_VERIFICATION = 'SIGNUP_TWILIO_VERIFICATION',
  SKILL_IQ_SCREEN_SHOT = 'SKILL_IQ_SCREEN_SHOT',
  SQS_QUEUE_URL_ORDER_POST_SAVE = 'SQS_QUEUE_URL_ORDER_POST_SAVE',
  START_CREAHANTON = 'START_CREAHANTON',
  STRIPE_SHOW_SAVE_CARDS = 'STRIPE_SHOW_SAVE_CARDS',
  TEMPORAL_ACCESS_MEMBERSHIP = 'TEMPORAL_ACCESS_MEMBERSHIP',
  TEMPORAL_ACCESS_USER_SEGMENT = 'TEMPORAL_ACCESS_USER_SEGMENT',
  TEMPORAL_ACCESS_VALIDATION = 'TEMPORAL_ACCESS_VALIDATION',
  TEMP_ACCESS_REGISTER_LAST_DAY = 'TEMP_ACCESS_REGISTER_LAST_DAY',
  TP_MARKETING_DATA = 'TP_MARKETING_DATA',
  TRACK_MEMBERSHIP_TRIAL = 'TRACK_MEMBERSHIP_TRIAL',
  TRIGGER_B2B_REPORT_BATCH = 'TRIGGER_B2B_REPORT_BATCH',
  TRIGGER_B2B_REPORT_SF = 'TRIGGER_B2B_REPORT_SF',
  UPDATE_ENROLLMENT_PERMISSIONS = 'UPDATE_ENROLLMENT_PERMISSIONS',
  UPSELL_PAYG_TO_MEMBERSHIP = 'UPSELL_PAYG_TO_MEMBERSHIP',
  USER_ACTIVITY_V2 = 'USER_ACTIVITY_V2',
  USER_INTEREST_INTERCOM = 'USER_INTEREST_INTERCOM',
  USER_INTEREST_MAILCHIMP = 'USER_INTEREST_MAILCHIMP',
  USER_NOTIFICATION = 'USER_NOTIFICATION',
  USER_NOTIFICATION_WEB = 'USER_NOTIFICATION_WEB',
  USER_REQUIRED_ALL_COURSES = 'USER_REQUIRED_ALL_COURSES',
  USER_REQUIRED_MEMBERSHIP = 'USER_REQUIRED_MEMBERSHIP',
  USER_SUMMARY = 'USER_SUMMARY',
  VALIDATE_CB_ITEM_CONTENT = 'VALIDATE_CB_ITEM_CONTENT',
  VIDEO_ANALYTICS = 'VIDEO_ANALYTICS',
  VIMEO_PLAYLISTS_ARCHIVED = 'VIMEO_PLAYLISTS_ARCHIVED',
  VIRAL_LOOP = 'VIRAL_LOOP',
}

export enum LiveTargetEnum {
  TARGET_HIDDEN = 'TARGET_HIDDEN',
  TARGET_PREMIUM = 'TARGET_PREMIUM',
  TARGET_PRIVATE = 'TARGET_PRIVATE',
  TARGET_PUBLIC = 'TARGET_PUBLIC',
}

export enum MembershipTypeMethod {
  A_1 = 'A_1',
  A_2 = 'A_2',
}

export enum MembershipTypeTag {
  BECADO = 'BECADO',
  FAMILIAR = 'FAMILIAR',
  ONG_BECADO = 'ONG_BECADO',
  ORGANIZATION = 'ORGANIZATION',
  PLUS = 'PLUS',
  PREMIUM = 'PREMIUM',
  PREMIUM_DUO = 'PREMIUM_DUO',
  PREMIUM_LITE = 'PREMIUM_LITE',
  PREMIUM_STUDENT = 'PREMIUM_STUDENT',
  PROFESIONAL = 'PROFESIONAL',
  UNIVERSITY_SCHOLARSHIP = 'UNIVERSITY_SCHOLARSHIP',
}

export enum MyUserTeam {
  B2B = 'B2B',
  DESIGN = 'DESIGN',
  EDUCATION = 'EDUCATION',
  FINANCE = 'FINANCE',
  HUMAN_RESOURCES = 'HUMAN_RESOURCES',
  MARKETING = 'MARKETING',
  OPERATIONS = 'OPERATIONS',
  PRODUCT = 'PRODUCT',
  PRODUCTION = 'PRODUCTION',
  TEACH = 'TEACH',
}

export enum MyUserTypeDocument {
  DNI = 'DNI',
  FOREIGNER_CARD = 'FOREIGNER_CARD',
  PASSPORT = 'PASSPORT',
}

export enum ProjectCreatedDateEnum {
  LAST_FIFTEEN_DAYS = 'LAST_FIFTEEN_DAYS',
  LAST_MONTH = 'LAST_MONTH',
}

export enum StatusProjectEnum {
  CERTIFIED = 'CERTIFIED',
  DRAFT = 'DRAFT',
  FINISHED = 'FINISHED',
  OBSERVED = 'OBSERVED',
  PUBLISHED = 'PUBLISHED',
}

export enum StudioCourseConfigStateEnum {
  HIDDEN = 'HIDDEN',
}

export enum UserB2BStatusEnum {
  ACTIVE = 'ACTIVE',
  DELETE = 'DELETE',
  INACTIVE = 'INACTIVE',
  PENDING = 'PENDING',
}

export enum UserDegreeSegmentationEnum {
  ACTIVATED_DEGREE_SEGMENTATION = 'ACTIVATED_DEGREE_SEGMENTATION',
  EXPIRED_DEGREE_SEGMENTATION = 'EXPIRED_DEGREE_SEGMENTATION',
}

export enum UserTagEnum {
  B2B = 'B2B',
  COLLEGE_SCHOLARSHIP = 'COLLEGE_SCHOLARSHIP',
  MENTOR = 'MENTOR',
  MENTOR_STAR = 'MENTOR_STAR',
  PLUS = 'PLUS',
  PREMIUM = 'PREMIUM',
  PREMIUM_LITE = 'PREMIUM_LITE',
  PREMIUM_STUDENT = 'PREMIUM_STUDENT',
  PROFESSIONAL = 'PROFESSIONAL',
  PROFESSOR = 'PROFESSOR',
  SCHOLARSHIP = 'SCHOLARSHIP',
  STAFF = 'STAFF',
}

export interface RecoverPasswordInput {
  value: string;
  nextUrl?: string | null;
  clientMutationId?: string | null;
}

export interface ReportFilterCustomFieldInput {
  customFieldId?: string | null;
  answers?: (string | null)[] | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
